import { Typography } from "@mui/material"

export const PHKOString = () => (
  <Typography variant="subtitle2">
    РНКО «Единая касса». ЦБ РФ №3512-К, 07.11.2016
  </Typography>
)
